import './index.css';
import Button from '../button';

const COMPLETE_TRY_IT_HREF = 'https://www.mako-app.com/voices';

function openVoicesInNewTab() {
  const w = window.open(COMPLETE_TRY_IT_HREF, '_blank');
  if (w) w.opener = null;
}

const ROADMAP_ITEMS = [
  {
    title: 'LinkedIn integration',
    description: 'Schedule and post directly from the Mako UI.',
    status: 'Complete',
  },
  {
    title: 'For You page',
    description:
      'Instead of tracking specific websites, enter keywords and Mako will track the web for you.',
    status: 'Testing',
  },
  {
    title: 'GitHub integration',
    description: 'Bring shipped work and roadmap signals from your repos into your monitoring workflow.',
    status: 'Scoping',
  },
  {
    title: 'Analytics',
    description:
      'A more fleshed out reporting suite, so you can gather trends and data on how the web is moving.',
    status: 'Scoping',
  },
];

function RoadmapList() {
  return (
    <ol className="roadmap-list" aria-label="Product roadmap">
      {ROADMAP_ITEMS.map((item, index) => (
        <li key={index} className="roadmap-list__item">
          <article className="roadmap-list__card">
            <span
              className={`roadmap-list__status roadmap-list__status--${item.status.toLowerCase()}`}
            >
              {item.status}
            </span>
            <h3 className="roadmap-list__title">{item.title}</h3>
            <p className="roadmap-list__description">{item.description}</p>
            {item.status === 'Complete' && (
              <div className="roadmap-list__try-it-wrap">
                <Button
                  text="Try it"
                  smallBool={true}
                  addedFunction={openVoicesInNewTab}
                />
              </div>
            )}
          </article>
        </li>
      ))}
    </ol>
  );
}

export default RoadmapList;
